var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 790,
    viewBox: "0 0 1440 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1443,
    height: 790,
    fill: "url(#paint0_linear_1510_6652)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 626.351,
    width: 345.63,
    height: 162.818,
    transform: "rotate(-45 2 626.351)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 764.562,
    width: 321.822,
    height: 155.843,
    transform: "rotate(-45 620 764.562)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 867,
    y: 635.562,
    width: 321.822,
    height: 155.843,
    transform: "rotate(-45 867 635.562)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 781.562,
    width: 321.822,
    height: 155.843,
    transform: "rotate(-45 18 781.562)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.33,
    y: 723.232,
    width: 394.894,
    height: 269.903,
    transform: "rotate(-45 1153.33 723.232)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 771,
    y: 856.232,
    width: 340.088,
    height: 191.228,
    transform: "rotate(-45 771 856.232)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 798.753,
    width: 589.377,
    height: 174.124,
    transform: "rotate(-45 238 798.753)",
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1231.73 746.506L857.219 372L722 507.219L1096.51 881.725L1231.73 746.506Z",
    fill: "white",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 374.167,
    height: 167.902,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 1041.08 771.576)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 284.74,
    height: 137.886,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 648.842 786.342)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 284.74,
    height: 195.163,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 200.842 730.342)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 517.005,
    height: 172.084,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 470.078 768.578)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 882.99,
    y: 816.682,
    width: 584.472,
    height: 137.886,
    transform: "rotate(-45 882.99 816.682)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 270.026,
    height: 137.886,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 1439.84 778.342)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 129.872,
    y: 725.47,
    width: 519.681,
    height: 151.525,
    transform: "rotate(-45 129.872 725.47)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 642.323,
    height: 137.886,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 853.691 799.191)",
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1510_6652",
    x1: 721,
    y1: 253.5,
    x2: 722.034,
    y2: 789.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55222,
    stopColor: "#BEDEFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login_background.2de0b5da5d65a32587d2cb82bbf7eaea.svg";
export { ForwardRef as ReactComponent };